import React from 'react'
import { Link } from 'react-router-dom'
import { Compass, Activity, Users, BarChart3 } from 'lucide-react'

export default function SolutionsProviderOrganizations() {
  return (
    <section className="section light" style={{ minHeight: '70vh' }}>
      <h2>Provider Organizations</h2>
      <p className="lead muted">
        Route patients more effectively across your network, support care teams with continuity alerts,
        and improve operational visibility across every location and provider.
      </p>

      <div className="cards">
        <div className="card"><Compass /><h3>Route patients more effectively</h3><p>Route incoming patients into the right provider across your network using structured intake data, not availability alone.</p></div>
        <div className="card"><Activity /><h3>Continuity alerts for care teams</h3><p>Give care teams a heads-up when a patient may be drifting away from care, before it becomes a dropout.</p></div>
        <div className="card"><BarChart3 /><h3>Operational visibility</h3><p>See caseload, continuity, and engagement patterns across your entire organization, not just one location.</p></div>
        <div className="card"><Users /><h3>Scales with your network</h3><p>The same routing and continuity layer extends across every location and provider as your organization grows.</p></div>
      </div>

      <p className="muted" style={{ marginTop: 24 }}>
        Built for multi-location behavioral health organizations and provider networks — from a handful of
        clinics to organizations operating across regions.
      </p>

      <div className="actions" style={{ marginTop: 20 }}>
        <Link to="/contact">Request Demo</Link>
        <Link className="secondary outline-dark" to="/how-it-works">See How It Works</Link>
      </div>
    </section>
  )
}
